import styled from 'styled-components/macro';

export const CalendarContainer = styled.div`
  display: inline-block;
  width: 100%;
`;
